import { gql, Variables } from 'graphql-request';
import type { ViaxOrder } from '@types';

interface SetPromoCodesToCartSuccess {
  status: 'OK',
  data: ViaxOrder;
}

interface SetPromoCodesToCartError {
  status: 'ERROR',
  errors: { code: string }[];
}

export interface SetPromoCodesToCartResponse {
  wSetPromoCodes: {
    result: SetPromoCodesToCartSuccess | SetPromoCodesToCartError
  };
}

export interface SetPromoCodesToCartVariables extends Variables {
  orderUid: string;
  promoCodes: string[];
}

export const SET_PROMO_CODE_TO_CART_MUTATION = gql`
  mutation setPromoCodes($orderUid: String!, $promoCodes: [String]!) {
    wSetPromoCodes(orderUid: $orderUid, promoCodes: $promoCodes)
  }
`;
